export default __webpack_public_path__ + "static/media/peopleconnect.7fdf6374.png";